<div [formGroup]="itemForm" class="card">
  @if (isWhatsappPhone() || isContactName()) {
    <div class="card-body">
      <div class="mb-1">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
              [disabled]="isActive"
              [attr.aria-label]="'integrations.webhookItem.remove' | translate"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>
        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="col-xs-12 mb-1">
        <textarea
          #messageTextarea
          class="form-control mb-1"
          maxlength="320"
          [placeholder]="'integrations.webhookItem.placeholderType' | translate"
          formControlName="value"
          (keydown)="onKeydown($event)"
        ></textarea>
        <field-error-component
          [field]="'value'"
          [label]="'integrations.fields.value' | translate"
          [formGroup]="itemForm"
        />
        <div class="col-12">
          <div class="request-container">
            @for (request of webhookRequests | keyvalue; track $index) {
              <div class="d-flex mb-2">
                <span
                  class="fw-bold text-dark me-1"
                  (click)="!isActive && addValue(request.key)"
                >
                  {{ request.key }}:
                </span>
                <span class="text-break">{{ request.value }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  } @else if (isAddTag() || isRemoveTag()) {
    <div class="card-body">
      <div class="mb-1">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="col-12">
        <div class="mb-1 position-relative" style="z-index: 1">
          <select
            class="form-select"
            formControlName="value"
            panelClass="custom-select-panel"
          >
            @for (item of tags; track item) {
              <option [value]="item._id">{{ item.title }}</option>
            }
          </select>
          <field-error-component
            [field]="'value'"
            [label]="'integrations.fields.tag' | translate"
            [formGroup]="itemForm"
          />
        </div>
      </div>
    </div>
  } @else if (isCreateOpportunity()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="funnel"
            (selectionChange)="loadStagesByFunnel()"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectFunnel' | translate
            "
          >
            @for (item of funnels; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'funnel'"
            [label]="'integrations.fields.funnel' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="stage"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectStage' | translate
            "
          >
            @for (item of stages; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'stage'"
            [label]="'integrations.fields.stage' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="user"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectResponsible'
                | translate
            "
          >
            @for (item of users; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'user'"
            [label]="'integrations.fields.responsible' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="product"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectProduct' | translate
            "
          >
            @for (item of products; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'product'"
            [label]="'integrations.fields.product' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            formControlName="priority"
            class="form-control"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectPriority' | translate
            "
          >
            <mat-option>{{
              "integrations.webhookItem.priorityNone" | translate
            }}</mat-option>
            <mat-option [value]="'LOW'">{{
              "integrations.webhookItem.priorityLow" | translate
            }}</mat-option>
            <mat-option [value]="'MEDIUM'">{{
              "integrations.webhookItem.priorityMedium" | translate
            }}</mat-option>
            <mat-option [value]="'HIGH'">{{
              "integrations.webhookItem.priorityHigh" | translate
            }}</mat-option>
            <mat-option [value]="'URGENT'">{{
              "integrations.webhookItem.priorityUrgent" | translate
            }}</mat-option>
          </mat-select>
          <field-error-component
            [field]="'user'"
            [label]="'integrations.fields.responsible' | translate"
            [formGroup]="itemForm"
          />
        </div>
      </div>
    </div>
  } @else if (isStartAttendance()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="value"
            (selectionChange)="loadUsersByDepartment()"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectDepartment' | translate
            "
          >
            @for (item of departments; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'value'"
            [label]="'integrations.fields.department' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="attendent"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectAttendant' | translate
            "
          >
            @for (item of usersByDepartment; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'attendent'"
            [label]="'integrations.fields.attendant' | translate"
            [formGroup]="itemForm"
          />
        </div>
      </div>
    </div>
  } @else if (isCloseAttendance()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
    </div>
  } @else if (isTransferAttendance()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="department"
            (selectionChange)="loadUsersByDepartment()"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectDepartment' | translate
            "
          >
            @for (item of departments; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'department'"
            [label]="'integrations.fields.department' | translate"
            [formGroup]="itemForm"
          />
        </div>
        <div class="mb-1">
          <mat-select
            class="form-control"
            formControlName="user"
            [placeholder]="
              'integrations.webhookItem.placeholderSelectAttendant' | translate
            "
          >
            @for (item of usersByDepartment; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
            }
          </mat-select>
          <field-error-component
            [field]="'user'"
            [label]="'integrations.fields.attendant' | translate"
            [formGroup]="itemForm"
          />
        </div>
      </div>
    </div>
  } @else if (isCreateTracking()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
    </div>
  } @else if (isOriginLead()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          {{ itemForm.get("helpText")?.value || getMessage() }}
        </p>
      </div>
      <div class="mb-1">
        <mat-select
          class="form-control"
          formControlName="originLead"
          [placeholder]="
            'integrations.webhookItem.placeholderSelectOrigin' | translate
          "
        >
          @for (item of leadSources; track item) {
            <mat-option [value]="item._id">{{ item.name }}</mat-option>
          }
        </mat-select>
        <field-error-component
          [field]="'originLead'"
          [label]="'integrations.fields.origin' | translate"
          [formGroup]="itemForm"
        />
      </div>
    </div>
  } @else if (isSendMessage()) {
    <div class="card-body">
      <div class="mb-1">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>
          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          @if (hasRcsEditor()) {
            {{ "integrations.webhookItem.rcsMessageHelp" | translate }}
          } @else {
            {{ itemForm.get("helpText")?.value || getMessage() }}
          }
        </p>
      </div>
      @if (hasRcsEditor()) {
        <!-- An RCS action is composed in the same editor as RCS campaigns (RcsMessageModule). -->
        <div class="row mt-2">
          <div class="col-lg-8">
            <rcs-message-editor
              [group]="rcsGroup"
              [readonly]="isActive"
              [uploadType]="RCS_UPLOAD_TYPE"
              [variables]="requestVariables"
              [cardVariables]="true"
            />
          </div>
          <div class="col-lg-4">
            <rcs-message-preview [rcsData]="rcsGroup.getRawValue()" />
          </div>
        </div>
      } @else {
        <div class="col-xs-12 mb-1">
          <div class="mb-1">
            <small class="text-muted">{{
              "integrations.webhookItem.selectMessageType" | translate
            }}</small>
            <mat-select class="form-control" formControlName="typeMessage">
              <mat-option [value]="'text'">{{
                "integrations.webhookItem.messageTypeText" | translate
              }}</mat-option>
              <mat-option [value]="'image'">{{
                "integrations.webhookItem.messageTypeImage" | translate
              }}</mat-option>
              <mat-option [value]="'audio'">{{
                "integrations.webhookItem.messageTypeAudio" | translate
              }}</mat-option>
              <mat-option [value]="'video'">{{
                "integrations.webhookItem.messageTypeVideo" | translate
              }}</mat-option>
              <mat-option [value]="'document'">{{
                "integrations.webhookItem.messageTypeDocument" | translate
              }}</mat-option>
              <mat-option [value]="'button'">{{
                "integrations.webhookItem.messageTypeButtons" | translate
              }}</mat-option>
            </mat-select>
            <field-error-component
              [field]="'typeMessage'"
              [label]="'integrations.fields.messageType' | translate"
              [formGroup]="itemForm"
            />
          </div>
          <div class="col-12 mb-1">
            @if (
              isTypeMessageMedia() &&
              itemForm.get("typeMessage").value !== "button"
            ) {
              <input
                class="form-control"
                maxlength="100"
                formControlName="caption"
                [placeholder]="
                  'integrations.webhookItem.placeholderCaption' | translate
                "
              />
            }
          </div>
          <div class="col-xs-12 mb-1">
            @if (itemForm.get("typeMessage").value !== "button") {
              <textarea
                #messageTextarea
                formControlName="value"
                class="form-control mb-1"
                (keydown)="onKeydown($event)"
                [placeholder]="
                  'integrations.webhookItem.placeholderType' | translate
                "
                maxlength="320"
                rows="5"
                (paste)="onPaste($event)"
              ></textarea>
              <field-error-component
                [field]="'value'"
                [label]="'integrations.fields.text' | translate"
                [formGroup]="itemForm"
              />
              <div
                class="d-flex align-items-center justify-content-end gap-2 mt-2"
              >
                <i
                  class="mdi mdi-format-bold fs-4 pointer"
                  (click)="!isActive && applyFormat('bold')"
                ></i>
                <i
                  class="mdi mdi-format-italic fs-4 pointer"
                  (click)="!isActive && applyFormat('italic')"
                ></i>
                <i
                  class="mdi mdi-format-underline fs-4 pointer"
                  (click)="!isActive && applyFormat('underline')"
                ></i>

                <i
                  class="mdi mdi-emoticon fs-4 pointer"
                  (click)="!isActive && toogleContainerEmoji()"
                ></i>
                <div
                  #emojiContainer
                  class="position-relative"
                  id="emoji-container"
                >
                  @if (showContainerEmoji) {
                    <ng-container>
                      <emoji-mart
                        (emojiSelect)="!isActive && addEmoji($event)"
                        [i18n]="translator"
                        [darkMode]="false"
                        class="position-absolute bottom-300 end-0 lg:bottom-100"
                      >
                      </emoji-mart>
                    </ng-container>
                  }
                </div>
                <button
                  class="btn btn-primary fw-bold dropdown-toggle"
                  type="button"
                  [matMenuTriggerFor]="menuRequest2"
                >
                  {{ "integrations.webhookItem.addRequests" | translate }}
                </button>
                <mat-menu #menuRequest2="matMenu">
                  @for (request of webhookRequests | keyvalue; track $index) {
                    <button
                      class="text-center"
                      mat-menu-item
                      (click)="!isActive && insertRequestOnMessage(request.key)"
                    >
                      {{ request.key }}
                    </button>
                  }
                </mat-menu>
              </div>
            }
          </div>
        </div>

        @if (itemForm.get("typeMessage").value === "button") {
          <div class="row">
            <div class="col-12">
              <app-button-zapi-component
                [buttonActionsArray]="getButtonActionsFormArray()"
                [maxButtons]="3"
                [showFullMessage]="true"
                [title]="itemForm.get('title').value"
                [message]="itemForm.get('value').value"
                [footer]="itemForm.get('footer').value"
                (titleChange)="itemForm.get('title').setValue($event)"
                (messageChange)="itemForm.get('value').setValue($event)"
                (footerChange)="itemForm.get('footer').setValue($event)"
              >
              </app-button-zapi-component>
            </div>
          </div>
        }
      }
    </div>
  } @else if (isAddTemplate()) {
    <div class="card-body">
      <div class="mb-1">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>
          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <!-- template list -->
        <wa-template-select
          [channel]="channel"
          [selectedTemplateId]="$safeNavigationMigration(selectedTemplate?.id)"
          (onSelectTemplate)="onSelectTemplate($event)"
        ></wa-template-select>

        @if (showPreviewTemplate) {
          <!-- template params and preview -->
          <webhook-integration-wa-template-message
            [template]="selectedTemplate"
            [webhookRequests]="webhookRequests"
            [webhookIntegrations]="webhookIntegrations"
            (templateParams)="setTemplateMessage($event)"
          />
        }
      </div>
    </div>
  } @else if (isTriggerMessage()) {
    <div class="card-body">
      <div class="mb-2">
        <div class="d-flex align-items-start justify-content-between">
          <label class="text-dark fw-bold mb-1" style="font-size: 20px">
            {{ getLabel() }}
          </label>

          @if (!isRequired()) {
            <button
              type="button"
              class="btn btn-link p-0 ms-2"
              (click)="!isActive && deleteComponent()"
            >
              <i class="bi bi-trash fs-4 text-danger"></i>
            </button>
          }
        </div>

        <p class="text-muted mb-0">
          @if (hasRcsEditor()) {
            {{ "integrations.webhookItem.rcsTriggerHelp" | translate }}
          } @else {
            {{ itemForm.get("helpText")?.value || getMessage() }}
          }
        </p>
      </div>

      <div class="col-12 mb-1">
        <input
          class="form-control"
          maxlength="255"
          formControlName="nameTriggerMessage"
          [placeholder]="
            'integrations.webhookItem.placeholderTriggerName' | translate
          "
        />
      </div>
      <div class="col-12 mb-1">
        <input
          class="form-control"
          maxlength="255"
          [placeholder]="
            'integrations.webhookItem.placeholderTriggerKeywords' | translate
          "
          formControlName="keysTriggerMessage"
          (keydown.enter)="addKeyword($event)"
        />
        <div class="d-flex flex-wrap gap-2 mb-2">
          @for (item of keywords; track item) {
            <div
              class="badge bg-primary d-flex align-items-center justify-content-between p-1 mt-2 fs-5"
            >
              <span>
                {{ item }}
              </span>
              <i
                class="ri-close-line p-1 pointer"
                (click)="removeTriggerKeyword(item)"
              ></i>
            </div>
          }
        </div>
      </div>
      @if (hasRcsEditor()) {
        <!-- An RCS action is composed in the same editor as RCS campaigns (RcsMessageModule). -->
        <div class="row mt-2">
          <div class="col-lg-8">
            <rcs-message-editor
              [group]="rcsGroup"
              [readonly]="isActive"
              [uploadType]="RCS_UPLOAD_TYPE"
              [variables]="requestVariables"
              [cardVariables]="true"
            />
          </div>
          <div class="col-lg-4">
            <rcs-message-preview [rcsData]="rcsGroup.getRawValue()" />
          </div>
        </div>
      } @else {
        <div class="col-12 mb-1">
          <div class="mb-1">
            <mat-select
              class="form-control"
              formControlName="typeMessage"
              [placeholder]="
                'integrations.webhookItem.selectMessageType' | translate
              "
            >
              <mat-option [value]="'text'">{{
                "integrations.webhookItem.messageTypeText" | translate
              }}</mat-option>
              <mat-option [value]="'image'">{{
                "integrations.webhookItem.messageTypeImage" | translate
              }}</mat-option>
              <mat-option [value]="'audio'">{{
                "integrations.webhookItem.messageTypeAudio" | translate
              }}</mat-option>
              <mat-option [value]="'video'">{{
                "integrations.webhookItem.messageTypeVideo" | translate
              }}</mat-option>
              <mat-option [value]="'document'">{{
                "integrations.webhookItem.messageTypeDocument" | translate
              }}</mat-option>
            </mat-select>
            <field-error-component
              [field]="'typeMessage'"
              [label]="'integrations.fields.messageType' | translate"
              [formGroup]="itemForm"
            />
          </div>
        </div>
        @if (isTypeMessageMedia()) {
          <div class="col-12 mb-1">
            <input
              class="form-control"
              maxlength="1000"
              formControlName="caption"
              [placeholder]="
                'integrations.webhookItem.placeholderCaption' | translate
              "
            />
          </div>
        }
        <div class="col-12">
          <textarea
            #messageTextarea
            formControlName="value"
            class="form-control mb-1"
            (keydown)="onKeydown($event)"
            [placeholder]="'integrations.webhookItem.placeholderType' | translate"
            maxlength="5000"
            (paste)="onPaste($event)"
          ></textarea>
          <field-error-component
            [field]="'value'"
            [label]="'integrations.fields.text' | translate"
            [formGroup]="itemForm"
          />
          <div class="d-flex align-items-center justify-content-end gap-2 mt-2">
            <i
              class="bi bi-type-bold fs-4 pointer"
              (click)="!isActive && applyFormat('bold')"
            ></i>
            <i
              class="bi bi-type-italic fs-4 pointer"
              (click)="!isActive && applyFormat('italic')"
            ></i>
            <i
              class="bi bi-type-underline fs-4 pointer"
              (click)="!isActive && applyFormat('underline')"
            ></i>

            <i
              class="bi bi-emoji-smile fs-4 pointer"
              (click)="!isActive && toogleContainerEmoji()"
            ></i>
            <div
              #emojiContainer
              class="position-relative"
              id="emoji-container"
              style="display: none"
            >
              @if (showContainerEmoji) {
                <ng-container>
                  <emoji-mart
                    (emojiSelect)="!isActive && addEmoji($event)"
                    [i18n]="translator"
                    [darkMode]="false"
                    class="position-absolute bottom-300 end-0 lg:bottom-100"
                  >
                  </emoji-mart>
                </ng-container>
              }
            </div>
            <button
              class="btn btn-primary fw-bold dropdown-toggle"
              type="submit"
              [matMenuTriggerFor]="menuRequest1"
            >
              {{ "integrations.webhookItem.addRequests" | translate }}
            </button>
            <mat-menu #menuRequest1="matMenu">
              @for (request of webhookRequests | keyvalue; track $index) {
                <button
                  class="text-center"
                  mat-menu-item
                  (click)="!isActive && insertRequestOnMessage(request.key)"
                >
                  {{ request.key }}
                </button>
              }
            </mat-menu>
          </div>
        </div>
      }
      <div class="col-12 mt-2">
        <input
          class="form-control"
          formControlName="urlTriggerMessage"
          [placeholder]="
            'integrations.webhookItem.placeholderForwardWebhook' | translate
          "
        />
      </div>
    </div>
  } @else {
    @if (!showPreviewTemplate) {
      <webhook-integration-wa-template
        [channel]="channel"
        (onSelectTemplate)="onSelectTemplate($event)"
      />
    }

    @if (showPreviewTemplate) {
      <div>
        <div class="d-flex justify-content-between align-items-center p-3">
          <button
            type="button"
            class="btn btn-outline-secondary rounded"
            (click)="!isActive && changeTemplate()"
          >
            {{ "integrations.webhookItem.changeTemplate" | translate }}
          </button>
        </div>

        <webhook-integration-wa-template-message
          [template]="selectedTemplate"
          [webhookRequests]="webhookRequests"
          [webhookIntegrations]="webhookIntegrations"
          (templateParams)="setTemplateMessage($event)"
        />
      </div>
    }
  }
</div>
